<template>
    <form autocomplete="off">
        <div class="font-semibold text-lg mb-4 flex justify-between">
            {{ $t("personalDetails") }}
        </div>
        <div class="grid md:grid-cols-3 gap-3">
            <k-select
                class="mb-4"
                id="gender"
                :label="$t('gender')"
                v-model="form.gender"
                :options="genders"
                value-key="value"
                label-key="label"
                :field-errors="validation.fieldErrors"/>
            <k-date-select class="mb-4"
                           id="dateOfBirth"
                           label="Date of birth"
                           v-model="form.dateOfBirth"
                           placeholder="yyyy-mm-dd"
                           :selectableYearRange="{ from : 1910, to: 2020 }"
                           :field-errors="validation.fieldErrors"/>
            <k-select
                class="mb-4"
                id="countryOfBirth"
                :label="$t('countryOfBirth')"
                v-model="form.countryOfBirth"
                :options="countries"
                value-key="code"
                label-key="name"
                :field-errors="validation.fieldErrors"/>
        </div>

        <div class="font-semibold text-lg mt-4 mb-4">
            {{ $t("residentialAddress") }}
        </div>
        <k-select
            class="mb-4"
            id="residenceAddressCountry"
            :label="$t('country')"
            v-model="form.residenceAddressCountry"
            :options="countries"
            value-key="code"
            label-key="name"
            :field-errors="validation.fieldErrors"/>
        <div class="grid md:grid-cols-3 gap-3">
            <k-input
                class="mb-4"
                id="residenceAddressPostalCode"
                :label="$t('postalCode')"
                v-model="form.residenceAddressPostalCode"
                :field-errors="validation.fieldErrors"/>
            <k-input
                class="mb-4"
                id="residenceAddressCity"
                :label="$t('city')"
                v-model="form.residenceAddressCity"
                :field-errors="validation.fieldErrors"/>
            <k-input
                class="mb-4"
                id="residenceAddressStreet"
                :label="$t('street')"
                v-model="form.residenceAddressStreet"
                :field-errors="validation.fieldErrors"/>
        </div>

        <div class="font-semibold text-lg mt-4 mb-4">
            {{ $t("citizenship") }}
        </div>
        <k-select
            class="mb-4"
            id="countryOfCitizenship"
            :label="$t('country')"
            v-model="form.countryOfCitizenship"
            :options="countries"
            value-key="code"
            label-key="name"
            :field-errors="validation.fieldErrors"/>

        <k-checkbox
            class="mb-4"
            id="singaporePermanentResident"
            v-model="form.singaporePermanentResident"
            :label="$t('iAmSingaporeResident')"
            :field-errors="validation.fieldErrors"
        />

        <div class="grid md:grid-cols-2 gap-3" v-show="!form.singaporePermanentResident">
            <k-input
                class="mb-4"
                id="passportNumber"
                :label="$t('passportNumber')"
                v-model="form.passportNumber"
                :field-errors="validation.fieldErrors"/>

            <k-date-select class="mb-4"
                           id="passportExpiryDate"
                           :label="$t('passportExpiry')"
                           v-model="form.passportExpiryDate"
                           placeholder="yyyy-mm-dd"
                           :field-errors="validation.fieldErrors"/>
        </div>
        <k-input
            v-show="form.singaporePermanentResident"
            class="mb-4"
            id="singaporeNricNumber"
            :label="$t('nricNumber')"
            v-model="form.singaporeNricNumber"
            :field-errors="validation.fieldErrors"/>
        <k-select
            class="mb-4"
            id="taxResidenceCountry"
            :label="$t('taxResidence')"
            v-model="form.taxResidenceCountry"
            :options="countries"
            value-key="code"
            label-key="name"
            :field-errors="validation.fieldErrors"/>
        <k-input
            class="mb-4"
            id="taxIdentificationNumber"
            :label="$t('taxIdNumber')"
            v-model="form.taxIdentificationNumber"
            :field-errors="validation.fieldErrors"/>
        <div class="mt-6">
            <k-button @click.native.prevent="onSubmit">
                {{ $t("submit") }}
            </k-button>
        </div>
    </form>
</template>

<script>
import countries from '@product-common/data/countries';
import genders from '@product-common/data/genders';
import KDateSelect from '@investor/components/KDateSelect';

export default {
    components: {
        KDateSelect
    },
    props: {
        validation: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                gender: '',
                dateOfBirth: null,
                countryOfBirth: null,
                residenceAddressCountry: '',
                residenceAddressPostalCode: '',
                residenceAddressCity: '',
                residenceAddressStreet: '',
                countryOfCitizenship: '',
                passportNumber: '',
                passportExpiryDate: '',
                taxResidenceCountry: '',
                taxIdentificationNumber: ''
            },
            countries: countries,
            genders: genders
        };
    },
    async mounted() {
        let personalDetails = {}
        try {
            const {data} = await this.$http.get('/api/investor/public/personal-details')
            personalDetails = data

        } catch (e) {
            console.error(e)
        }
        if (!this.$isProd && personalDetails == null) {
            try {
                const {data} = await this.$http.get('/api/investor/public/fake-personal-details', {});
                personalDetails = data
            } catch (e) {
                console.error(e)
            }
        }
        this.form = personalDetails;
    },
    methods: {
        async onSubmit() {
            this.$emit('submit', this.form);
        }
    }
};
</script>

<style>

</style>

